import MoveItemToAnotherCollectionModal from './MoveItemToAnotherCollectionModal.container'
export default MoveItemToAnotherCollectionModal
